// extracted by mini-css-extract-plugin
export default {"ModalContainer":"EndTrialPeriodModal_ModalContainer__yxQD8"};